import { useAuthQuery, UseQueryExtendedOptions } from "@bn/api";
import { getAccountBalances } from "@api/v1/methods";
import { DateValuePair } from "@api/v1/model";
import { ACCOUNT_BALANCES } from "../../cacheKeys";

interface Params {
  accountIds: number[];
  from?: Date;
  to?: Date;
}

export const useAccountBalances = (
  params: Params,
  options?: UseQueryExtendedOptions<
    { dateValuePairs: DateValuePair[] },
    AxiosApiError,
    { dateValuePairs: DateValuePair[] }
  >
) =>
  useAuthQuery<
    { dateValuePairs: DateValuePair[] },
    AxiosApiError,
    { dateValuePairs: DateValuePair[] }
  >(
    [ACCOUNT_BALANCES, params],
    ({ token }) =>
      getAccountBalances(token, {
        id: params.accountIds,
        from: params.from?.toISOString(),
        to: params.to?.toISOString(),
      }),
    options
  );
